import { finishComponent } from './finish.component';
import { stateResolver } from '../../app.state';

export const finishStateName = 'app.finish';

export const finishState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/finish',
    name: finishStateName,
    component: finishComponent.name,
    resolve: { stateResolver: stateResolver(finishStateName) },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/finish/finish.state.js